import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Layout from "layouts/DashboardManage";
import { addUser } from "store/actions/userAction";
import { getAllRoles } from "store/actions/roleAction";
import hasProperty from "lodash/has";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import Selectbox from "components/Forms/Elements/Selectbox";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class Add extends Component {
  state = {
    fullname: "",
    password: "",
    password_confirmation: "",
    user_type: "desktop",
    role: "",
    roleName: ""
  };

  componentDidMount() {
    this.props.getAllRoles({ type: this.state.user_type });
  }

  componentDidUpdate(prevProps) {
    // When the new user is created successfully, we will redirect to step 2
    if (
      prevProps.addUserResponse !== this.props.addUserResponse &&
      hasProperty(this, "props.addUserResponse.id")
    ) {
      // Redirect to manage page
      return this.props.history.push(`/manage/users`);
    }

    // When there was a problem creating the new User
    if (
      prevProps.errorUser !== this.props.errorUser &&
      this.props.errorUser &&
      Object.keys(this.props.errorUser).length > 0
    ) {
      notifyApiError(this.props.errorUser);
    }
  }

  handleChange = e => {
    const target = e.target;
    this.setState(prevState => ({
      ...prevState,
      [target.name]: target.value
    }));
  };

  handleCreate = () => {
    this.props.addUser(this.state);
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit">
          <h1 className="title mb-30">{Translate({ id: "add_user" })} </h1>

          <div className="center-form">
            <div className="form-wrapper mb-20">
              <div className="form-group mb-10">
                <label htmlFor="fullname">
                  * {Translate({ id: "fullname" })} :
                </label>
                <Textbox
                  type="text"
                  placeholder="John Doe"
                  id="fullname"
                  name="fullname"
                  fieldValue={this.state.fullname}
                  onChange={this.handleChange}
                  onReturnKey={this.handleCreate}
                  errors={this.props.errorUser}
                  errorKey="fullname"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="email">* {Translate({ id: "email" })} :</label>
                <Textbox
                  type="email"
                  placeholder="user@example.com"
                  id="email"
                  name="email"
                  fieldValue={this.state.email}
                  onChange={this.handleChange}
                  onReturnKey={this.handleCreate}
                  errors={this.props.errorUser}
                  errorKey="email"
                  formErrorClass="form-error"
                />
                <div className="help">
                  {Translate({
                    id: "this_will_be_used_by_the_user_to_login_to_the_system_this_can_be_changed_later"
                  })}
                </div>
              </div>
              <div className="form-group mb-10">
                <label htmlFor="password">
                  * {Translate({ id: "password" })} :
                </label>
                <Textbox
                  type="password"
                  id="password"
                  name="password"
                  fieldValue={this.state.password}
                  onChange={this.handleChange}
                  onReturnKey={this.handleCreate}
                  errors={this.props.errorUser}
                  errorKey="password"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="password_confirmation">
                  * {Translate({ id: "retype_password" })} :
                </label>
                <Textbox
                  type="password"
                  id="password_confirmation"
                  name="password_confirmation"
                  fieldValue={this.state.password_confirmation}
                  onChange={this.handleChange}
                  onReturnKey={this.handleCreate}
                  errors={this.props.errorUser}
                  errorKey="password_confirmation"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="type">
                  * {Translate({ id: "user_type" })} :
                </label>
                <Selectbox
                  id="user_type"
                  name="user_type"
                  onChange={e => {
                    this.handleChange(e);
                    this.props.getAllRoles({ type: e.target.value });
                  }}
                  errors={this.props.errorUser}
                  errorKey="type"
                  fieldValue={this.state.user_type}
                  options={[
                    { label: "Desktop User", value: "desktop" },
                    { label: "Web User", value: "web" }
                  ]}
                />
                <div className="help mt-5">
                  {Translate({ id: "cannot_be_changed_later" })}{" "}
                </div>
              </div>
              <div className="form-group mb-10">
                <label htmlFor="role">* {Translate({ id: "role" })} :</label>
                <AutoSuggest
                  data={
                    hasProperty(this, "props.roles.data")
                      ? this.props.roles.data
                      : []
                  }
                  displayItemInList="name"
                  keyword={keyword =>
                    this.props.getAllRoles({
                      name: keyword,
                      type: this.state.user_type
                    })
                  }
                  onSelect={item =>
                    this.setState({ role: item.id, roleName: item.name })
                  }
                  placeholder={Translate({ id: "type_to_search_role" })}
                  fieldValue={this.state.roleName}
                  errors={this.props.errorUser}
                  errorKey="role"
                />
              </div>
            </div>
          </div>

          <div className="save-cancel-buttons">
            <Link
              to={`/manage/users`}
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="create"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleCreate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Add.propTypes = {
  addUser: PropTypes.func.isRequired,
  getAllRoles: PropTypes.func,
  roles: PropTypes.object,
  addUserResponse: PropTypes.object,
  errorUser: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    addUserResponse: state.user.addUser,
    roles: state.role.getAllRoles,
    errorUser: state.user.errorUser,
    isLoading: state.user.isLoadingUser || state.role.isLoadingRole
  };
};

export default connect(mapStateToProps, { addUser, getAllRoles })(Add);
